import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import {Message} from 'element-ui'
import '@//styles/nprogress.css' // progress bar style
import {getToken} from '@/utils/auth' // get token from cookie
import {getExchange} from '@/utils'
import getPageTitle from '@/utils/get-page-title'
import Cookies from 'js-cookie'
import _ from "lodash";

NProgress.configure({showSpinner: false}) // NProgress Configuration

const whiteList = ['/login', '/register', '/unsubscribe', '/verify', '/forgot-pwd', '/reset-pwd', '/policy', '/product/detail', '/auth/enter'] // no redirect whitelist

//保存营销ID
function saveAffCookie(path) {
  const key = "vip-";
  const affIdIndex = path.indexOf(key);
  if (affIdIndex == -1) {
    return;
  }
  const affId = path.substr(affIdIndex + key.length);
  Cookies.set("affiliate_id", affId)
}

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  // 管理端代登入口：不要用旧 cookie 先拉用户信息，交给 enter 页清会话并换 token
  if (to.path === '/auth/enter') {
    next()
    NProgress.done()
    return
  }

  // determine whether the user has logged in
  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({path: '/'})
      NProgress.done()
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      const hasRoles = store.getters.roles && store.getters.roles.length > 0
      if (hasRoles) {
        next()
      } else {
        try {
          // get user info
          // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          const roles = ["admin"]
          await store.dispatch("user/setRoles", roles);
          const permissions = await store.dispatch("user/filterPermission", roles);
          await store.dispatch("user/info");
          // generate accessible routes map based on roles
          const accessRoutes = await store.dispatch('permission/generateRoutes', permissions)
          // dynamically add accessible routes
          // router.addRoutes(accessRoutes)
          await getExchange();
          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next({...to, replace: true})
        } catch (error) {
          // remove token and go to login page to re-login
          Message.error(error || 'Has Error')
          //next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/
    const find = _.find(whiteList, function (o) {
      return _.startsWith(to.path, o)
    });
    if (find) {
      // in the free login whitelist, go directly
      next()
    } else {
      const path = to.path;
      saveAffCookie(path);
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
